module.exports = __webpack_public_path__ + "static/media/white-mute-audio-icon.0ca39201.svg";